import { render, staticRenderFns } from "./Carts.vue?vue&type=template&id=bc62ca82&scoped=true"
import script from "./Carts.vue?vue&type=script&lang=ts"
export * from "./Carts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc62ca82",
  null
  
)

export default component.exports